import React from 'react'

export function getPopUpMessage(stepLabel: string): JSX.Element {
    return popUpMessages[stepLabel]
}

export function popUpMessagesDoesNotHave(stepLabel: string): boolean {
    return !popUpMessages.hasOwnProperty(stepLabel)
}

const popUpMessages: { [key: string]: JSX.Element } = {
    "Fundraising": <p>You’ll be asked to provide:
                        <ol className="pop-up-list-indent">
                            <li>Total amount you’ve raised</li>
                            <li>Amount raised in last round</li>
                            <li>Date of last raise</li>
                            <li>Type of funds raised in your last round (If SAFE, whether it was capped or uncapped. If capped, we’ll need the valuation cap. If Equity, we will need the price per share).</li>
                        </ol>
                    </p>,
    "Shareholders": <p>Provide up to 5 of your top shareholders, including the firm, general partner, and whether they have a board seat or voting rights.</p>,
    "Milestones": <p>Provide the top 2 milestones you’re tracking with your investors over the next 24 months, as well as a brief description of each milestone and the approximate number of months you’re aiming to achieve each milestone.</p>,
    "Documents": <p>You’ll be asked to upload:
                <ol className="pop-up-list-indent">
                    <li>Detailed cap table</li>
                    <li>SAFE agreement (if a SAFE was raised)</li>
                    <li>Board deck (if applicable)</li>
                    <li>Financial projections (if applicable)</li>
                    <li>409A valuation</li>
                    <li>Any other relevant documents that you think might provide us with a more complete picture of your company.</li>
                </ol>
            </p>,
    "Financials": <p>Depending on your fundraising details, you will be asked to provide historical financials in one of two ways:
                <ol className="pop-up-list-indent">
                    <li>Sync your accounting software (QuickBooks, Xero, Wave, NetSuite, etc.)</li>
                    <li>Upload a balance sheet and income statement for each quarter of the last 2 years</li>
                </ol>
                <br />
                If you choose option 2, you will also need to provide the following runway metrics:
                <ul className="pop-up-list-indent">
                    <li>Last fiscal year revenue</li>
                    <li>Last month's closed cash</li>
                    <li>Current fiscal year revenue</li>
                    <li>Total burn over the last 3 months</li>
                </ul>
            </p>
}